import React from "react";
import { Helmet } from "react-helmet";

const HelmetReact = ({ title }) => {
  return (
    <Helmet>
      <title>
        {title} || Grupo Rocvel - Soluções Estratégicas em RH
      </title>
      <meta
        name="description"
        content="O Grupo Rocvel desenvolve soluções corporativas em recrutamento e seleção estratégica, hunting de talentos e gestão de RH em todo o território nacional."
      />
    </Helmet>
  );
};

export default HelmetReact;